import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import CustomTooltip from './CustomTooltip';
import { formatCurrency } from '../../../utils/formatNumber';

const ReusableAreaChart = ({ data, dataKeys, width = 500, height = 300 }) => {
  const [keyLeft, keyRight] = Object.values(dataKeys); // Extraer dinámicamente las dos keys

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={width}
        height={height}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 50,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          angle={0}
          textAnchor="middle"
          interval={0}
          tickFormatter={(value) => (value.length > 20 ? `${value.slice(0, 20)}...` : value)}
        />
        <YAxis
          yAxisId="left"
          tickFormatter={(value) => `${formatCurrency(value, 0)}`}
          orientation="left"
          stroke="#e57373"
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          stroke="#b0bec5"
          tickFormatter={(value) => `${formatCurrency(value, 0)} €`}
        />
        <Tooltip content={<CustomTooltip dataKeys={dataKeys} />} />
        <Legend />
        <Area
          yAxisId="left"
          type="monotone"
          dataKey={keyLeft}
          stroke="#e57373"
          fillOpacity={0.3}
          fill="#e57373"
          connectNulls={true}
        />
        <Area
          yAxisId="right"
          type="monotone"
          dataKey={keyRight}
          stroke="#b0bec5"
          fillOpacity={0.3}
          fill="#b0bec5"
          connectNulls={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default ReusableAreaChart;
